export default "__VITE_ASSET__B86vgD75__"